import React from 'react';
import { displayCurrency, displayShortDate } from '../../utils/Format/Format';

import Tooltip from '../../components/Tooltip/Tooltip';
import tooltipIcon from '../../images/tooltip.svg';

import tooltipStyles from './ETFDistributionHistoryTooltip.css';

// const displayCurrencyFourDec = (v) => displayCurrency(v, 4);

const ST_TIP_LANGUAGE =
    'The difference between the purchase price of a security and the price at which it was sold, assuming the difference is positive and the investment gained in value. For tax purposes, the profit realized from the sale of securities or other capital assets held 12 months or less. Quarterly distributions are paid at the end of each quarter (March, June, September, and December). Annual distributions are paid in December.';
const LT_TIP_LANGUAGE =
    'The difference between the purchase price of a security and the price at which it was sold, assuming the difference is positive and the investment gained in value. For tax purposes, the profit realized from the sale of securities or other capital assets held for more than 12 months. Quarterly distributions are paid at the end of each quarter (March, June, September, and December). Annual distributions are paid in December.';

export const distHistoryUtil = (ticker) => (gqlResult) => {
    if (!gqlResult) {
        return null;
    }

    const {
        exchangeTradedFund: { distribution = [] }
    } = gqlResult;

    const scheduleFrequency =
        (distribution && distribution.distributionFrequency) || 'N/A';

    const headers = [
        '',
        'Ex-Date',
        'Record date',
        'Pay Date',
        'Income',
        <Tooltip
            key="etf-st-cap-gains-tooltip"
            title={<span className="etf-tip-title">S/T Cap Gains</span>}
            content={<div className="etf-tip-content">{ST_TIP_LANGUAGE}</div>}
        >
            S/T Cap Gains
            <img
                className="tooltip-img"
                src={tooltipIcon}
                height="14px"
                alt="Expense Limitations Tooltip"
            />
            <style jsx>{tooltipStyles}</style>
        </Tooltip>,
        <Tooltip
            key="etf-lt-cap-gains-tooltip"
            title={<span className="etf-tip-title">L/T Cap Gains</span>}
            content={<div className="etf-tip-content">{LT_TIP_LANGUAGE}</div>}
        >
            L/T Cap Gains
            <img
                className="tooltip-img"
                src={tooltipIcon}
                height="14px"
                alt="Expense Limitations Tooltip"
            />
            <style jsx>{tooltipStyles}</style>
        </Tooltip>,
        'Total Distribution'
    ];

    // filter out distributions older than 2 years
    let processedDistributions = distribution.distributions.filter(
        (singleDistribution) => {
            // chop UTC timezone off of string used to build date so it doesn't mess things up
            // this is because today and twoYearsAgo are client local time
            const exDateObj = new Date(singleDistribution.exDate.split('T')[0]);
            const today = new Date();
            const twoYearsAgo = new Date().setFullYear(today.getFullYear() - 2);
            return exDateObj > twoYearsAgo;
        }
    );

    // sort distributions by age
    processedDistributions = processedDistributions.sort((a, b) => {
        // timezones should be fine because all exDates are UTC
        const aDate = new Date(a.exDate);
        const bDate = new Date(b.exDate);
        // swapped so that the most recent distributions are first
        return bDate - aDate;
    });

    const data = processedDistributions.map((ele) => ({
        label: null,
        values: [
            {
                'ex-date':
                    ele.exDate && ele.exDate.length !== 0
                        ? displayShortDate(ele.exDate)
                        : '--'
            },
            {
                'record-date':
                    ele.recordDate && ele.recordDate.length !== 0
                        ? displayShortDate(ele.recordDate)
                        : '--'
            },
            {
                'pay-date':
                    ele.payDate && ele.payDate.length !== 0
                        ? displayShortDate(ele.payDate)
                        : '--'
            },
            {
                'income-data':
                    ele.income && ele.income.length !== 0
                        ? displayCurrency(ele.income)
                        : '--'
            },
            {
                'short-term-cap-gains':
                    ele.shortTermCapitalGains &&
                    ele.shortTermCapitalGains.length !== 0
                        ? displayCurrency(ele.shortTermCapitalGains)
                        : '--'
            },
            {
                'long-term-cap-gains':
                    ele.longTermCapitalGains &&
                    ele.longTermCapitalGains.length !== 0
                        ? displayCurrency(ele.longTermCapitalGains)
                        : '--'
            },
            {
                'total-distro':
                    ele.totalDistribution && ele.totalDistribution.length !== 0
                        ? displayCurrency(ele.totalDistribution)
                        : '--'
            }
        ]
    }));
    return {
        data,
        scheduleFrequency,
        headers,
        ticker
    };
};
